import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';
import { API_HOST } from '../../config/app-const';
import localStorage from '../../helpers/localStorage';

const state = {
  briefMappings: {
    isBusy: false,
    data: null,
    error: null,
    abortController: null
  }
};

const mutations = {
  LOAD_BRIEF_MAPPINGS_BUSY: (state, payload) => {
    state.briefMappings.isBusy = payload;
  },
  LOAD_BRIEF_MAPPINGS_SUCCESS: (state, payload) => {
    state.briefMappings.data = payload;
    state.briefMappings.error = null;
  },
  LOAD_BRIEF_MAPPINGS_FAIL: (state, payload) => {
    state.briefMappings.data = null;
    state.briefMappings.error = payload;
  },
  SET_BRIEF_MAPPINGS_ABORT_CONTROLLER(state, controller) {
    state.briefMappings.abortController = controller;
  },
};

const actions = {
  getBriefMappings: ({ commit }, { projectId, forceGet, categoryKey }) => {
    commit('LOAD_BRIEF_MAPPINGS_BUSY', true);

    const localStorageBrief = localStorage.getLocalStorage(`${projectId}_brief_mappings`) || { data: {} };

    let categoryIsMissing = false;
    let tagsAreAllPinned = false;
    const catKey = typeof categoryKey === 'string' ? categoryKey.split('.')[0] : categoryKey;
    if (catKey) {
      categoryIsMissing = !(catKey in localStorageBrief.data);
      if (catKey && !categoryIsMissing) {
        // If the category exists but all tags are pinned there's a high chance we didn't fetch this category yet
        const tags = Object.values(localStorageBrief.data).filter(dt => dt.type === 'tag' && dt.parent == catKey);
        tagsAreAllPinned = tags.length === tags.filter(dt => dt.pinned).length;
      }
    }

    if (Object.keys(localStorageBrief.data).length === 0 || forceGet || categoryIsMissing || tagsAreAllPinned) {

      // Cancel the previous request if there is one
      if (state.briefMappings?.abortController) {
        state.briefMappings.abortController?.cancel('cancelled');
        commit("SET_BRIEF_MAPPINGS_ABORT_CONTROLLER", null);
      }

      // Create a new AbortController/cancelToken instance for the current request
      // TODO: "remove this comment after update axios" -> (current old! axios version not supporting the AbortController api, they start to support it from v0.22.0) 
      const CancelToken = Axios.CancelToken;
      const controller = CancelToken.source();
      commit("SET_BRIEF_MAPPINGS_ABORT_CONTROLLER", controller);

      const config = {
        cancelToken: controller.token
      };

      let url = `/analysis/editor/${projectId}/brief_mappings`;
      if (catKey) {
        url += `?category_key=${encodeURIComponent(catKey)}`;
      }

      return Axios.get(url, config)
        .then(response => {
          localStorage.checkLocalStorageLength();
          try {
            localStorageBrief.data = { ...localStorageBrief.data, ...response.data.data };
            localStorage.setLocalStorage(`${projectId}_brief_mappings`, localStorageBrief);
          } catch (error) {
            // Unable to save brief mappings in local storage.
            // This potentially means the data exceeds local storage quota.
          }
          commit('LOAD_BRIEF_MAPPINGS_SUCCESS', localStorageBrief);
        })
        .catch(error => {
          if (Axios.isCancel(error)) {
            console.log('Request canceled => ', error.message);
          } else {
            //clear mappings from local storage if it is full
            localStorage.removeBriefMappingsFromLocalStorage()
            Vue.notify({
              group: 'store_notifications',
              type: 'error',
              text: i18n.t('messages.request.error')
            });

            commit('LOAD_BRIEF_MAPPINGS_FAIL', error);
          }
          return error;
        })
        .finally(() => commit('LOAD_BRIEF_MAPPINGS_BUSY', false));
    } else {
      commit('LOAD_BRIEF_MAPPINGS_SUCCESS', localStorageBrief);
      commit('LOAD_BRIEF_MAPPINGS_BUSY', false);
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};